import { CambiarClienteComponent } from '../../../../standalone/cambiar-cliente/cambiar-cliente.component';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IPopulate,
  IQueryParam,
  IActivo,
  IConfigReenvio,
  IFilter,
  IReporteBase,
  IReporteGenerico,
  IEventoGenerico,
  TipoVehiculo,
  FuncionActivo,
} from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import * as XLSX from 'xlsx-js-style';
import { DescargasService } from '../../../../navigation/descargas/service';
import { ActivosService } from '../../../../../auxiliares/servicios/http/activos.service';
import { ConfigReenviosService } from '../../../../../auxiliares/servicios/http/config-reenvios.service';
import { RecorridosDinamicosService } from '../../../../../auxiliares/servicios/http/recorridos-dinamicos.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IColumnas,
  ICrearBoton,
  IExportarBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { MapaFacilDialogComponent } from '../../../../../auxiliares/mapa-facil-dialog/mapa-facil-dialog.component';
import {
  MapaFacilData,
  Coordinate,
} from '../../../../../auxiliares/mapa-facil/interfaces';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { isModoDesactivadoActivo } from '../../../../../auxiliares/modo-desactivado.util';

import { LoginService } from '../../../../login/login.service';
import { ModoEstacionadoComponent } from '../modo-estacionado/modo-estacionado.component';
import { ParamsService } from '../../../../../auxiliares/servicios/params.service';
import { ModoDesactivadoDispositivoComponent } from '../../../../standalone/modo-desactivado-dispositivo/modo-desactivado-dispositivo.component';
import { EnviarComandoComponent } from '../enviar-comando/enviar-comando.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { DarAltaEntidadComponent } from '../../../../standalone/dar-alta-entidad/dar-alta-entidad.component';
import {
  CrearEditarEventoTecnicoGenericoComponent,
  ICrearEditarEventoTecnicoGenericoData,
} from '../../../eventos-genericos/eventos-tecnicos-genericos/crear-editar/crear-editar-evento-tecnico-generico.component';
import { EventosGenericosHttpService } from '../../../../../auxiliares/servicios/http/eventos-genericos.service';
import { ReportesGenericosService } from '../../../../../auxiliares/servicios/http/reportes-genericos.service';
import { ListadoAsignacionsComponent } from '../../../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { SincronizarSoflexComponent } from '../sincronizar-soflex/sincronizar-soflex.component';
import { AsignarConductorVehiculoComponent } from '../../../../standalone/choferes/asignar-conductor-vehiculo/asignar-conductor-vehiculo.component';
import { CrearReglaVehiculoComponent } from '../crear-regla-vehiculo/crear-regla-vehiculo.component';
import { QrVehiculoComponent } from '../qr-vehiculo/qr-vehiculo.component';
import {
  ExportarColumnasVehiculosComponent,
  IColumnaExport,
} from '../exportar-columnas-vehiculos/exportar-columnas-vehiculos.component';
import {
  EmergenciaAvlDialogComponent,
  IEmergenciaAvlData,
} from '../../../administracion/config-reenvios/emergencia-avl-dialog/emergencia-avl-dialog.component';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import {
  estadoConexionCelda,
  estadoHtml,
  fechaCelda,
  haceCelda,
} from '../../../../../auxiliares/tabla/celdas';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';

interface IActivoTabla extends IActivo {
  ultimoReporte?: IReporteBase<'Tracker 4G'>;
  color?: string;
}

@Component({
  selector: 'app-listado-vehiculos',
  templateUrl: './listado-vehiculos.component.html',
  styleUrl: './listado-vehiculos.component.scss',
  standalone: false,
})
export class ListadoVehiculosComponent implements OnInit, OnDestroy {
  private formularios = inject(FormularioDialogService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ActivosService);
  private configReenviosService = inject(ConfigReenviosService);
  private recorridosDinamicosService = inject(RecorridosDinamicosService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private paramsService = inject(ParamsService);
  private eventosService = inject(EventosGenericosHttpService);
  private reportesService = inject(ReportesGenericosService);
  private descargas = inject(DescargasService);

  public clientePropio = LoginService.getCliente();

  // Función fija que viene por la data de la ruta (ej. el listado del menú de
  // Servicio Técnico): se filtra siempre por ella y no se muestra el filtro.
  private funcionFija?: FuncionActivo = this.route.snapshot.data['funcion'];
  // Solo para ver: sin crear, sin Soflex y sin acciones salvo Detalles.
  private soloLectura = !!this.route.snapshot.data['soloLectura'];

  // Records completos: si se agrega un valor al enum en gestion-modelos no
  // compila hasta sumarlo acá, y los filtros de Tipo y Función salen de estos.
  private tiposLabel: Record<TipoVehiculo, string> = {
    Auto: 'Auto',
    Camion: 'Camión',
    Camioneta: 'Camioneta',
    Colectivo: 'Colectivo',
    Grua: 'Grúa',
    Moto: 'Moto',
    Otro: 'Otro',
  };
  private funcionesLabel: Record<FuncionActivo, string> = {
    Particular: 'Particular',
    'Seguridad Privada': 'Seguridad Privada',
    Mantenimiento: 'Mantenimiento',
    Transporte: 'Transporte',
    Bomberos: 'Bomberos',
    Policia: 'Policía',
    Ambulancia: 'Ambulancia',
    'Servicio Técnico': 'Servicio Técnico',
    Otro: 'Otro',
  };
  //// Tabla nueva
  // Con función fija usa otro nombre: no comparte con el listado general los
  // filtros guardados ni el tamaño de página.
  public name = this.funcionFija
    ? `ListadoVehiculosComponent-${this.funcionFija}`
    : 'ListadoVehiculosComponent';
  public activos?: IActivoTabla[];
  public totalCount = 0;
  public columnas?: IColumnas<IActivoTabla>[];
  public reportes: IReporteBase<'Tracker 4G'>[] = [];

  //Subs
  public reportes$?: Subscription;
  public trackers$?: Subscription;
  public activos$?: Subscription;
  public permiso = LoginService.getPermisoActual();
  //

  public botonCrear: ICrearBoton = {
    mostrar: !this.soloLectura && this.helper.tienePermiso('Vehículos - Crear'),
    tooltip: 'Crear Vehículo',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };

  public botonSoflex: IExportarBoton = {
    mostrar:
      !this.soloLectura &&
      this.helper.tienePermiso('Administración - Crear trackers'),
    tooltip: 'Sincronizar con Soflex',
    color: 'primary',
    tipo: 'material',
    icon: 'sync',
    accion: () => this.syncSoflex(),
  };

  public botonExportarExcel: IExportarBoton = {
    mostrar: true,
    tooltip: 'Exportar vehículos a Excel',
    color: 'primary',
    tipo: 'material',
    icon: 'file_download',
    accion: () => this.exportarVehiculos(),
  };
  public search: IRegExpSearch = {
    fields: [
      'identificacion',
      'vehiculo.patente',
      'vehiculo.marca',
      'vehiculo.modelo',
    ],
  };
  // FILTROS
  public tracker: IFiltroTabla = {
    filter: {
      field: 'idTracker',
    },
    label: 'Tracker',
    tipo: 'tracker-selector',
  };
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente Propietario',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloVehiculos'],
  };
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
    filtroSelector: ['moduloVehiculos'],
  };
  private tipo: IFiltroTabla = {
    // Sin Colectivo: lista2.vehiculos() los excluye (tienen su propio módulo).
    elementos: Object.entries(this.tiposLabel)
      .filter(([value]) => value !== 'Colectivo')
      .map(([value, label]) => ({ label, value })),
    filter: {
      field: 'vehiculo.tipo',
    },
    label: 'Tipo',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };
  private funcion: IFiltroTabla = {
    elementos: Object.entries(this.funcionesLabel).map(([value, label]) => ({
      label,
      value,
    })),
    filter: {
      field: 'funcion',
    },
    label: 'Función',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };
  private alta: IFiltroTabla = {
    elementos: [
      {
        label: 'Dado de alta',
        value: [{ fechaAlta: { $exists: true, $ne: null } }],
      },
      { label: 'Sin alta', value: [{ fechaAlta: null }] },
    ],
    filter: {
      field: '$or',
    },
    label: 'Alta',
    rapido: true,
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'value',
  };
  private flota: IFiltroTabla = {
    filter: {
      field: 'idGrupo',
    },
    label: 'Flota',
    tipo: 'grupo-selector',
    categoriaGrupo: 'Flota',
  };
  /**
   * Estado de la última sincronización del vehículo con Soflex.
   * "No sincronizado" usa $ne: true porque los vehículos que nunca se enviaron
   * no tienen el campo (además de los que fallaron, que lo tienen en false).
   */
  private soflex: IFiltroTabla = {
    elementos: [
      { label: 'Sincronizado', value: true },
      { label: 'No sincronizado', value: { $ne: true } },
    ],
    filter: {
      field: 'sincronizadoSoflex',
    },
    label: 'Soflex',
    tipo: 'ngselect',
    selectLabel: 'label',
    selectValue: 'value',
    compararPorJson: true,
  };

  public filtros: IFiltroTabla[] = [
    this.tracker,
    this.tipo,
    ...(this.funcionFija ? [] : [this.funcion]),
    this.alta,
    this.flota,
  ];

  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre idPadre nivel idsAncestros',
    },
    {
      path: 'tracker',
      select: 'nombre tipo frecReporte idModelo uniqueId',
      populate: {
        path: 'modelo',
        select: 'idCodigos',
        populate: {
          path: 'codigos',
          select: 'codigosEntrada',
        },
      },
    },
    {
      path: 'vehiculo.recorrido',
      select: 'nombre color geojson',
    },
    {
      path: 'vehiculo.chofer',
      select: 'usuario identificacionInterna',
    },
    {
      path: 'grupo',
      select: 'nombre',
    },
  ];
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // La tabla reescribe query.filter con lo que eligió el usuario: la función
  // fija se agrega recién al pedir los datos.
  private conFuncionFija(query: IQueryParam): IQueryParam {
    if (!this.funcionFija) return query;
    const filter = HelperService.stringToObject(query.filter);
    filter['funcion'] = this.funcionFija;
    return { ...query, filter: JSON.stringify(filter) };
  }

  // Listars
  public async listar(): Promise<void> {
    this.activos$?.unsubscribe();
    this.activos$ = this.lista2
      .vehiculos(this.conFuncionFija(this.query), 30)
      .subscribe(async (data) => {
        this.totalCount = data.totalCount;
        await this.completaUltimoReporte(data.datos);
      });
  }

  //
  public async completaUltimoReporte(activos: IActivoTabla[]): Promise<void> {
    if (!activos.length) {
      this.emergenciasAvl = new Map();
      this.activos = [];
      return;
    }
    // En paralelo con los reportes; viaja en el mismo poll de 30 s, así una
    // emergencia que vence o se declara en otra pantalla se refleja sola.
    const emergencias = this.cargarEmergenciasAvl(activos);

    const idsActivos = activos.map((v) => v._id);
    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: { $in: idsActivos },
    };
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: '-fechaCreacion',
      includeChildren: true,
    };

    const data = await firstValueFrom(
      this.lista2.ultimosReportesGenericos<'Tracker 4G'>(query),
    );
    for (const activo of activos) {
      // const findReporte = data.find((r) => r.idActivo === activo._id);
      const findReporte = data.datos.find((r) =>
        r.idsAsignados.includes(activo._id),
      );
      activo.ultimoReporte = findReporte;
      if (activo.ultimoReporte) {
        const frecuenciaReporte = activo?.tracker?.frecReporte;
        const timeReporte = new Date(
          activo.ultimoReporte.fechaCreacion,
        ).getTime();
        const timeNow = new Date().getTime();
        const diff = timeNow - timeReporte;

        const frecuenciaEnMs = frecuenciaReporte * 60 * 1000;
        if (diff > 2 * frecuenciaEnMs) {
          activo.color = 'red';
        } else if (diff > frecuenciaEnMs && diff < 2 * frecuenciaEnMs) {
          activo.color = 'yellow';
        } else if (diff < frecuenciaEnMs) {
          activo.color = 'green';
        } else {
          activo.color = 'black';
        }
      }
    }
    this.emergenciasAvl = await emergencias;
    this.activos = activos;
  }

  /// Emergencias AVL vigentes por idTracker. Sin esto, declarada una
  /// emergencia el listado no mostraba nada y era fácil volver a declararla.
  public emergenciasAvl = new Map<string, IConfigReenvio>();

  private async cargarEmergenciasAvl(
    activos: IActivoTabla[],
  ): Promise<Map<string, IConfigReenvio>> {
    const vigentes = new Map<string, IConfigReenvio>();
    const idsTrackers = activos
      .map((a) => a.tracker?._id)
      .filter((id): id is string => !!id);
    if (!this.moduloAvlActivo || !idsTrackers.length) return vigentes;
    // La emergencia puede estar declarada sobre el vehículo (sigue al tracker
    // que tenga asignado): se la cuenta para su tracker actual.
    const trackerPorActivo = new Map<string, string>();
    for (const a of activos) {
      if (a._id && a.tracker?._id) trackerPorActivo.set(a._id, a.tracker._id);
    }
    try {
      const filter = {
        agrupacionReenvio: 'Entidad',
        idEntidadReenvio: {
          $in: [...idsTrackers, ...trackerPorActivo.keys()],
        },
        activo: true,
        'opcionesReenvio.metodo': 'Objetivo AVL',
      } as IFilter<IConfigReenvio>;
      const listado = await this.configReenviosService.getFiltered({
        filter: JSON.stringify(filter),
        // opcionesReenvio: el popup la usa en modo ajuste (nro. de carta).
        select:
          'idEntidadReenvio periodoInicio periodoFin activo opcionesReenvio',
        sort: '-fechaCreacion',
        limit: 200,
        excludeTotalCount: true,
        // Como el listado de vehículos (que ya trae los de los hijos): la
        // config puede estar a nombre de un cliente hijo.
        includeChildren: true,
        childrenLevel: 0,
      });
      // La vigencia se mira acá y no en el filtro: son pocas configs, y así
      // no depende de cómo se castee la fecha del lado de la API.
      const ahora = Date.now();
      for (const c of listado?.datos ?? []) {
        const id = c.idEntidadReenvio
          ? (trackerPorActivo.get(c.idEntidadReenvio) ?? c.idEntidadReenvio)
          : undefined;
        if (!id || vigentes.has(id)) continue;
        const empezo =
          !c.periodoInicio || new Date(c.periodoInicio).getTime() <= ahora;
        const sigue =
          !c.periodoFin || new Date(c.periodoFin).getTime() >= ahora;
        if (empezo && sigue) vigentes.set(id, c);
      }
    } catch (error) {
      // Sin permiso para ver configs de reenvío, o la API falló: el listado
      // sigue igual, solo sin el indicador.
      console.error('Error al buscar emergencias AVL vigentes', error);
    }
    return vigentes;
  }

  /** "16:04", o "24/09/2026 16:04" si no es hoy: una emergencia larga cruza el día. */
  private horaCorta(fecha: string): string {
    const d = new Date(fecha);
    const hora = d.toLocaleTimeString('es-AR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    if (d.toDateString() === new Date().toDateString()) return hora;
    const dia = d.toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    return `${dia} ${hora}`;
  }

  public emergenciaAvlDe(dato: IActivoTabla): IConfigReenvio | undefined {
    const id = dato.tracker?._id;
    return id ? this.emergenciasAvl.get(id) : undefined;
  }

  // Acciones

  public async ubicar(c: IActivoTabla) {
    const valores = this.helper.getValores(c.ultimoReporte);
    if (!valores?.geojson?.coordinates) return;
    const coord: Coordinate = [
      valores.geojson.coordinates[0],
      valores.geojson.coordinates[1],
    ];
    const data: MapaFacilData = {
      markers: [{ coor: coord, label: 'vehiculo' }],
    };
    this.formularios.abrir(MapaFacilDialogComponent, {
      tamano: 'grande',
      data,
      cerrarAfuera: true,
    });
  }

  // Acciones
  public async crear() {
    this.paramsService.setParams({});
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async syncSoflex() {
    const res = this.formularios.abrir(SincronizarSoflexComponent, {
      tamano: 'mediano',
    });
    // No necesitamos refrescar la lista después de sincronizar
  }

  public async darAlta(data: IActivo) {
    this.formularios.abrir(DarAltaEntidadComponent, {
      tamano: 'mediano',
      data: { vehiculo: data },
    });
  }

  public async actualizarImagenes(data: IActivo) {
    this.formularios.abrir(DarAltaEntidadComponent, {
      tamano: 'mediano',
      data: { vehiculo: data },
    });
  }

  public async cambiarCliente(activo: IActivo) {
    const dialogRef = this.formularios.abrir(CambiarClienteComponent, {
      tamano: 'mediano',
      data: {
        entidad: activo,
        tipoEntidad: 'Vehículo',
      },
    });
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public async asignarConductor(vehiculo: IActivoTabla): Promise<void> {
    const dialogRef = this.formularios.abrir(
      AsignarConductorVehiculoComponent,
      {
        tamano: 'chico',
        data: { vehiculo, tipo: 'Conductor' },
      },
    );
    dialogRef.afterClosed().subscribe(async (resultado) => {
      if (resultado) {
        await this.listar();
      }
    });
  }

  public async editar(vehiculo: IActivo) {
    this.paramsService.setParams({ vehiculo });
    this.navigator.navigate(['editar'], {
      relativeTo: this.route,
    });
  }

  public verDetalles(vehiculo: IActivo): void {
    this.navigator.navigate([
      'main/vehiculos/vehiculos/detalles',
      vehiculo._id,
    ]);
  }
  public async configs(data: IActivo) {
    this.navigator.navigate(
      ['main/administracion/configEventos', data.idTracker],
      {},
    );
  }

  public async modoDesactivado(activo: IActivo) {
    this.formularios.abrir(ModoDesactivadoDispositivoComponent, {
      tamano: 'chico',
      data: { activo: activo },
    });
  }

  public async modoEstacionado(activo: IActivo) {
    this.formularios.abrir(ModoEstacionadoComponent, {
      tamano: 'chico',
      data: { activo },
    });
  }

  public crearReglaEvento(activo: IActivo) {
    CrearReglaVehiculoComponent.open(this.formularios, { activo });
  }

  public async generarQr(activo: IActivo) {
    this.formularios.abrir(QrVehiculoComponent, {
      tamano: 'chico',
      data: { activo },
      cerrarAfuera: true,
    });
  }

  public async enviarComando(activo: IActivo) {
    this.formularios.abrir(EnviarComandoComponent, {
      tamano: 'chico',
      data: { activo },
    });
  }

  /**
   * Vuelve el flag de Soflex a false para que la próxima sincronización vuelva
   * a enviar este vehículo (la sync sólo manda los pendientes).
   */
  public async desmarcarSoflex(activo: IActivo) {
    const res = await this.dialogService.confirm(
      'Marcar como no sincronizado',
      `¿Querés marcar ${activo.identificacion || activo.vehiculo?.patente} como no sincronizado con Soflex? Se volverá a enviar en la próxima sincronización.`,
    );
    if (!res) return;
    try {
      await this.service.desmarcarSoflex(activo._id!);
      this.helper.notifSuccess('Vehículo marcado como no sincronizado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  /**
   * Da por terminado el recorrido dinámico asignado ahora mismo: calcula y
   * persiste el cumplimiento definitivo, y libera al vehículo para poder
   * asignarle otro sin esperar a que pase el tiempo ni borrar este.
   */
  public async finalizarRecorridoDinamico(activo: IActivo) {
    const id = activo.vehiculo?.idRecorridoDinamico;
    if (!id) return;
    const res = await this.dialogService.confirm(
      'Finalizar recorrido dinámico',
      `¿Dar por terminado el recorrido dinámico asignado a ${activo.identificacion}? Se calcula el cumplimiento final y el vehículo queda libre para asignarle otro.`,
      'Finalizar',
      'Cancelar',
    );
    if (!res) return;
    try {
      await this.recorridosDinamicosService.finalizar(id);
      this.helper.notifSuccess('Recorrido dinámico finalizado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async eliminar(activo: IActivo) {
    const res = await this.dialogService.confirm(
      'Eliminar Activo',
      `¿Querés eliminar el activo ${activo.identificacion}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(activo._id!);
      this.helper.notifSuccess('Activo eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async eventoTecnico(activo: IActivo) {
    const data: ICrearEditarEventoTecnicoGenericoData = {
      idEntidad: activo._id!,
      tipoEvento: 'Evento Técnico Vehículo',
      categoria: 'Vehículo',
      idsCQAET: [this.clientePropio!._id!],
      idTracker: activo.idTracker,
    };

    this.formularios.abrir(CrearEditarEventoTecnicoGenericoComponent, {
      tamano: 'grande',
      data,
    });
  }

  public async exportarEventos(activo: IActivo) {
    const rango = await this.dialogService.dateRange(
      'Exportar Eventos',
      'Seleccioná el rango de fechas para exportar los eventos',
    );
    if (!rango) return;

    const filter: IFilter<IEventoGenerico> = {
      idEntidad: activo._id,
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'activo',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Fecha',
          key: 'fechaCreacion',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Categoría',
          key: 'categoria',
          placeholder: 'Sin categoría',
        },
        {
          header: 'Entidad',
          key: 'activo.identificacion',
        },
        {
          header: 'Tipo Evento',
          key: 'tipoEvento',
        },
        {
          header: 'Estado',
          key: 'estado',
        },
        {
          header: 'Evento',
          key: 'valores.titulo',
          placeholder: 'Sin título',
        },
        {
          header: 'Detalles',
          key: 'valores.mensaje',
          placeholder: 'Sin detalles',
        },
        {
          header: 'Fecha Evento',
          key: 'valores.timestamp',
          transform: 'fechaHora' as const,
        },
      ],
      sheetName: 'Eventos',
      autoFilter: true,
    };

    try {
      await this.eventosService.exportar(query, config, activo.identificacion);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async exportarReportes(activo: IActivo) {
    const rango = await this.dialogService.dateRange(
      'Exportar Reportes',
      'Seleccioná el rango de fechas para exportar los reportes',
    );
    if (!rango) return;

    const filter: IFilter<IReporteGenerico> = {
      idsAsignados: activo._id,
      tipoReporte: 'Tracker 4G',
      fechaCreacion: {
        $gte: rango?.start,
        $lte: rango?.end,
      },
    };

    const populate: IPopulate[] = [
      {
        path: 'activo',
        select: 'identificacion',
      },
      {
        path: 'cliente',
        select: 'nombre',
      },
    ];

    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      sort: 'fechaCreacion',
      page: 0,
      limit: 0,
      unlimited: true,
      includeChildren: true,
      populate: JSON.stringify(populate),
    };

    const config = {
      columns: [
        {
          header: 'Fecha',
          key: 'fechaCreacion',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Cliente',
          key: 'cliente.nombre',
        },
        {
          header: 'Vehículo',
          key: 'activo.identificacion',
        },
        {
          header: 'Fecha Device',
          key: 'valores.fechaDevice',
          transform: 'fechaHora' as const,
        },
        {
          header: 'Latitud',
          key: 'valores.geojson.coordinates.1',
          placeholder: '-',
        },
        {
          header: 'Longitud',
          key: 'valores.geojson.coordinates.0',
          placeholder: '-',
        },
        {
          header: 'Velocidad (km/h)',
          key: 'valores.velocidad',
          transform: 'velocidad' as const,
          placeholder: '0',
        },
        {
          header: 'Orientación',
          key: 'valores.orientacion',
          transform: 'orientacionBrujula' as const,
          placeholder: '-',
        },
        {
          header: 'Ignición',
          key: 'valores.ignicion',
          transform: 'booleanSiNo' as const,
          placeholder: '-',
        },
        {
          header: 'Odómetro (km)',
          key: 'valores.odometro',
          transform: 'kilometros' as const,
          placeholder: '0',
        },
        {
          header: 'Estado Tripero',
          key: 'valores.triperoState',
          placeholder: 'Desconocido',
        },
        {
          header: 'Dirección',
          key: 'valores.direccion',
          placeholder: 'Sin dirección',
        },
      ],
      sheetName: 'Reportes',
      autoFilter: true,
    };

    try {
      await this.reportesService.exportar(query, config, activo.identificacion);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  private async exportarVehiculos(): Promise<void> {
    const esClienteFinal = HelperService.getTipoCliente() === 'Final';

    const columnas: IColumnaExport[] = [
      { key: 'identificacion', label: 'Identificación', activa: true },
      { key: 'tipo', label: 'Tipo', activa: true },
      { key: 'funcion', label: 'Función', activa: true },
      { key: 'marca', label: 'Marca', activa: true },
      { key: 'modelo', label: 'Modelo', activa: true },
      { key: 'anio', label: 'Año', activa: true },
      { key: 'patente', label: 'Patente', activa: true },
      { key: 'tracker', label: 'Tracker', activa: true },
      { key: 'flota', label: 'Flota', activa: true },
      { key: 'recorrido', label: 'Recorrido', activa: true },
      { key: 'conductor', label: 'Conductor', activa: true },
      { key: 'fechaAlta', label: 'Fecha Alta', activa: true },
    ];
    if (!esClienteFinal) {
      columnas.push({ key: 'cliente', label: 'Cliente', activa: true });
    }

    const ref = this.formularios.abrir(ExportarColumnasVehiculosComponent, {
      tamano: 'chico',
      data: columnas,
    });
    const columnasSeleccionadas: IColumnaExport[] | undefined =
      await firstValueFrom(ref.afterClosed());
    if (!columnasSeleccionadas?.length) return;

    const activas = new Set(columnasSeleccionadas.map((c) => c.key));

    const queryExport: IQueryParam = this.conFuncionFija({
      ...this.query,
      page: 0,
      limit: 0,
      unlimited: true,
    });

    const fecha = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    const nombre = `vehiculos_${fecha}.xlsx`;
    const tiposLabel = this.tiposLabel;
    const funcionesLabel = this.funcionesLabel;
    const helper = this.helper;

    this.descargas.agregarDescargaExcel(nombre, async () => {
      const res = await firstValueFrom(this.lista2.vehiculos(queryExport, 0));
      const datos = res.datos as IActivoTabla[];

      const filas = datos.map((v) => {
        const row: Record<string, string> = {};
        if (activas.has('identificacion'))
          row['Identificación'] = v.identificacion ?? '-';
        if (activas.has('tipo'))
          row['Tipo'] = v.vehiculo?.tipo
            ? (tiposLabel[v.vehiculo.tipo as TipoVehiculo] ?? v.vehiculo.tipo)
            : '-';
        if (activas.has('funcion'))
          row['Función'] = v.funcion
            ? (funcionesLabel[v.funcion as FuncionActivo] ?? v.funcion)
            : '-';
        if (activas.has('marca')) row['Marca'] = v.vehiculo?.marca ?? '-';
        if (activas.has('modelo')) row['Modelo'] = v.vehiculo?.modelo ?? '-';
        if (activas.has('anio'))
          row['Año'] = v.vehiculo?.anio ? String(v.vehiculo.anio) : '-';
        if (activas.has('patente'))
          row['Patente'] = v.vehiculo?.patente
            ? helper.formatPatente(v.vehiculo.patente)
            : '-';
        if (activas.has('tracker')) row['Tracker'] = v.tracker?.nombre ?? '-';
        if (activas.has('flota')) row['Flota'] = v.grupo?.nombre ?? '-';
        if (activas.has('recorrido'))
          row['Recorrido'] = (v.vehiculo?.recorrido as any)?.nombre ?? '-';
        if (activas.has('conductor'))
          row['Conductor'] = (v.vehiculo?.chofer as any)?.usuario ?? '-';
        if (activas.has('fechaAlta'))
          row['Fecha Alta'] = v.fechaAlta
            ? new Date(v.fechaAlta).toLocaleDateString('es-AR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })
            : '-';
        if (activas.has('cliente')) row['Cliente'] = v.cliente?.nombre ?? '-';
        return row;
      });

      const ws = XLSX.utils.json_to_sheet(filas);

      const jsonData = XLSX.utils.sheet_to_json(ws, {
        header: 1,
      }) as string[][];
      if (jsonData.length) {
        const colCount = jsonData.reduce(
          (max, row) => Math.max(max, row.length),
          0,
        );
        ws['!cols'] = Array.from({ length: colCount }, (_, col) => ({
          wch: Math.min(
            Math.max(
              jsonData.reduce(
                (max, row) =>
                  Math.max(max, row[col] != null ? String(row[col]).length : 0),
                0,
              ) + 2,
              10,
            ),
            60,
          ),
        }));
      }

      const range = XLSX.utils.decode_range(ws['!ref'] ?? 'A1');
      for (let col = range.s.c; col <= range.e.c; col++) {
        const addr = XLSX.utils.encode_cell({ r: 0, c: col });
        if (ws[addr]) {
          ws[addr].s = {
            font: { bold: true },
            alignment: { horizontal: 'center' },
          };
        }
      }

      const buffer = XLSX.write(
        { Sheets: { Vehículos: ws }, SheetNames: ['Vehículos'] },
        { bookType: 'xlsx', type: 'array', cellStyles: true },
      );
      return new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
    });

    this.helper.notifSuccess('Exportación iniciada — ver panel de Descargas');
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<IActivoTabla>[] = [
      // Identificación + Tipo/Función
      {
        header: {
          label: 'Vehículo',
          sortable: true,
          sort: 'identificacion',
        },
        row: {
          html: (dato) => {
            const identificacion = dato.identificacion || 'Sin identificación';
            const tipo = dato.vehiculo?.tipo || '';
            const funcion = dato.funcion || '';
            const tipoLabel = tipo
              ? (this.tiposLabel[tipo as TipoVehiculo] ?? tipo)
              : '';
            const funcionLabel = funcion
              ? (this.funcionesLabel[funcion as FuncionActivo] ?? funcion)
              : '';

            let html = `<div class="tabla-celda-col">`;
            html += `<span class="tabla-principal">${escaparHtml(identificacion)}</span>`;

            const secundario = [tipoLabel, funcionLabel].filter(Boolean);
            if (secundario.length) {
              html += `<span class="tabla-secundario">${secundario.map((t) => escaparHtml(t)).join(' · ')}</span>`;
            }

            if (isModoDesactivadoActivo(dato.modoDesactivado)) {
              html += `<span>${estadoHtml({ texto: 'Desactivado', tono: 'neutro', icono: 'do_not_disturb_on' })}</span>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.identificacion)
              items.push(
                `<div>Identificación: <strong>${escaparHtml(dato.identificacion)}</strong></div>`,
              );
            if (dato.vehiculo?.tipo)
              items.push(
                `<div>Tipo: <strong>${escaparHtml(this.tiposLabel[dato.vehiculo.tipo as TipoVehiculo] ?? dato.vehiculo.tipo)}</strong></div>`,
              );
            if (dato.funcion)
              items.push(
                `<div>Función: <strong>${escaparHtml(this.funcionesLabel[dato.funcion as FuncionActivo] ?? dato.funcion)}</strong></div>`,
              );
            if (isModoDesactivadoActivo(dato.modoDesactivado))
              items.push(`<div><strong>Dispositivo Desactivado</strong></div>`);
            return items.length > 0 ? items.join('') : undefined;
          },
        },
      },

      // Detalles del vehículo (marca, modelo, año, patente) + Ignición
      {
        header: {
          label: 'Detalles',
          sortable: false,
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-fila">`;

            // Ícono de ignición
            const ignicion = dato.ultimoReporte?.valores?.ignicion;
            if (ignicion !== undefined && ignicion !== null) {
              const ignicionOn = ignicion === true;
              const iconColor = ignicionOn
                ? 'var(--color-green-icon)'
                : 'var(--color-gray-icon)';
              const iconName = ignicionOn ? 'key' : 'key_off';
              const title = ignicionOn
                ? 'Ignición encendida'
                : 'Ignición apagada';
              html += `<span class="material-symbols-outlined tabla-icono-dato" style="color: ${iconColor};" title="${title}">${iconName}</span>`;
            }

            // Información del vehículo
            html += `<div class="tabla-celda-col">`;

            if (dato.vehiculo?.marca || dato.vehiculo?.modelo) {
              let vehiculoText = '';
              if (dato.vehiculo?.marca) vehiculoText += dato.vehiculo.marca;
              if (dato.vehiculo?.modelo)
                vehiculoText += ` ${dato.vehiculo.modelo}`;
              if (dato.vehiculo?.anio)
                vehiculoText += ` (${dato.vehiculo.anio})`;

              html += `<span class="tabla-principal">${escaparHtml(vehiculoText.trim())}</span>`;
            }

            if (dato.vehiculo?.patente) {
              html += `<span class="tabla-codigo">${escaparHtml(this.helper.formatPatente(dato.vehiculo.patente))}</span>`;
            }

            html += `</div></div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];

            const ignicion = dato.ultimoReporte?.valores?.ignicion;
            if (ignicion !== undefined && ignicion !== null) {
              const ignicionOn = ignicion === true;
              const estado = ignicionOn
                ? '<span style="color: var(--color-green-icon);"><span class="material-icons" style="font-size: 12px; vertical-align: middle;">circle</span> Encendida</span>'
                : '<span style="color: var(--color-gray-icon);"><span class="material-icons" style="font-size: 12px; vertical-align: middle;">circle</span> Apagada</span>';
              items.push(`<div>Ignición: ${estado}</div>`);
            }

            if (dato.vehiculo?.marca)
              items.push(
                `<div>Marca: <strong>${escaparHtml(dato.vehiculo.marca)}</strong></div>`,
              );
            if (dato.vehiculo?.modelo)
              items.push(
                `<div>Modelo: <strong>${escaparHtml(dato.vehiculo.modelo)}</strong></div>`,
              );
            if (dato.vehiculo?.anio)
              items.push(
                `<div>Año: <strong>${escaparHtml(dato.vehiculo.anio)}</strong></div>`,
              );
            if (dato.vehiculo?.patente)
              items.push(
                `<div>Patente: <strong>${escaparHtml(this.helper.formatPatente(dato.vehiculo.patente))}</strong></div>`,
              );

            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin datos del vehículo',
        },
      },

      // Tracker + Flota/Recorrido
      {
        header: {
          label: 'Asignación',
          sortable: false,
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;

            if (dato.tracker?.nombre) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">gps_fixed</span>
                <span>${escaparHtml(dato.tracker.nombre)}</span>
              </div>`;
            }

            if (dato.grupo?.nombre) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">workspaces</span>
                <span>${escaparHtml(dato.grupo.nombre)}</span>
              </div>`;
            }

            if (dato.vehiculo?.recorrido?.nombre) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">route</span>
                <span>${escaparHtml(dato.vehiculo.recorrido.nombre)}</span>
              </div>`;
            }

            if (dato.vehiculo?.chofer?.usuario) {
              html += `<div class="tabla-linea">
                <span class="material-symbols-outlined">account_box</span>
                <span>${escaparHtml(dato.vehiculo.chofer.usuario)}</span>
              </div>`;
            }

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            const items: string[] = [];
            if (dato.tracker?.nombre)
              items.push(
                `<div>Tracker: <strong>${escaparHtml(dato.tracker.nombre)}</strong></div>`,
              );
            if (dato.grupo?.nombre)
              items.push(
                `<div>Flota: <strong>${escaparHtml(dato.grupo.nombre)}</strong></div>`,
              );
            if (dato.vehiculo?.recorrido?.nombre)
              items.push(
                `<div>Recorrido: <strong>${escaparHtml(dato.vehiculo.recorrido.nombre)}</strong></div>`,
              );
            if (dato.vehiculo?.chofer?.usuario)
              items.push(
                `<div>Conductor: <strong>${escaparHtml(dato.vehiculo.chofer.usuario)}</strong></div>`,
              );
            return items.length > 0 ? items.join('') : undefined;
          },
          noData: 'Sin asignaciones',
        },
      },

      // Fecha de alta + Última comunicación (combinados)
      {
        header: {
          label: 'Estado',
          sortable: true,
          sort: 'fechaAlta',
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;

            // Emergencia AVL vigente: primero y en rojo, es lo que no se
            // puede pasar por alto.
            const emergencia = this.emergenciaAvlDe(dato);
            if (emergencia) {
              const hasta = emergencia.periodoFin
                ? ` hasta ${this.horaCorta(emergencia.periodoFin)}`
                : '';
              html += `<span>${estadoHtml({ texto: `Emergencia AVL${hasta}`, tono: 'error', icono: 'emergency_share' })}</span>`;
            }

            // Comunicación: el mismo criterio que el detalle del vehículo,
            // con la fecha del último reporte y "hace x"
            const fechaReporte = dato.ultimoReporte?.fechaCreacion;
            html += `<span>${estadoHtml(estadoConexionCelda(fechaReporte, dato.tracker?.frecReporte))}</span>`;
            if (fechaReporte) {
              html += `<span class="tabla-secundario">${fechaCelda(fechaReporte)} · ${haceCelda(fechaReporte)}</span>`;
            }

            // Fecha de alta
            html += dato.fechaAlta
              ? `<span class="tabla-secundario">Alta ${fechaCelda(dato.fechaAlta).slice(0, 10)}</span>`
              : `<span class="tabla-secundario no-info">Sin alta</span>`;

            html += `</div>`;
            return html;
          },
          tooltip: (dato) => {
            let html =
              '<div style="display: flex; flex-direction: column; gap: 6px;">';

            const emergencia = this.emergenciaAvlDe(dato);
            if (emergencia) {
              html += `<div><span class="material-symbols-outlined" style="font-size: 13px; vertical-align: middle;">emergency_share</span> Transmitiendo a Policía de la Ciudad${
                emergencia.periodoFin
                  ? ` hasta el <strong>${fechaCelda(emergencia.periodoFin)}</strong>`
                  : ''
              }</div>`;
            }

            // Sección Alta
            if (dato.fechaAlta) {
              html += `<div>Alta: <strong>${fechaCelda(dato.fechaAlta)}</strong></div>`;
            } else {
              html += `<div>Sin fecha de alta</div>`;
            }

            // Sección Comunicación
            if (dato.ultimoReporte?.fechaCreacion) {
              const fechaUltimaComunicacion = new Date(
                dato.ultimoReporte.fechaCreacion,
              );
              html += `<div>Último reporte: <strong>${fechaCelda(fechaUltimaComunicacion)}</strong></div>`;

              const frecuenciaReporte = dato.tracker?.frecReporte;
              if (frecuenciaReporte) {
                html += `<div>Frecuencia de reporte: <strong>${frecuenciaReporte} min</strong></div>`;
              } else {
                html += `<div style="opacity: 0.7;">Sin frecuencia de reporte configurada</div>`;
              }
            } else {
              html += `<div style="opacity: 0.7;">Sin comunicación registrada</div>`;
            }

            html += '</div>';
            return html;
          },
        },
      },
    ];

    // Cliente. Se muestra además la jerarquía de clientes en un tooltip: con
    // varios clientes de nombre parecido el nombre solo no alcanza para saber
    // de quién cuelga el vehículo.
    if (HelperService.getTipoCliente() !== 'Final') {
      columnas.push({
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          noData: 'Sin cliente',
        },
      });
    }

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        accionesGrouped: [
          // Detalles
          {
            tipo: 'material',
            color: 'primary',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
          // Editar
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso('Vehículos - Editar'),
          },
          // Eliminar
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso('Vehículos - Eliminar'),
          },
          {
            tipo: 'material',
            icon: 'more_vert',
            tooltip: 'Más acciones',
            children: [
              // Exportar Eventos
              {
                tipo: 'material',
                color: 'primary',
                icon: 'file_download',
                tooltip: 'Exportar Eventos',
                click: (dato) => this.exportarEventos(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Exportar eventos'),
              },
              // Exportar Reportes
              {
                tipo: 'material',
                color: 'primary',
                icon: 'description',
                tooltip: 'Exportar Reportes',
                click: (dato) => this.exportarReportes(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Exportar Reportes'),
              },
              // Dar de Alta
              {
                tipo: 'material',
                color: 'primary',
                icon: 'event_available',
                tooltip: 'Dar de Alta',
                click: (dato) => this.darAlta(dato),
                oculta: (dato) => !!dato.fechaAlta,
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Dar de alta'),
              },
              // Actualizar imagenes
              {
                tipo: 'material',
                color: 'primary',
                icon: 'add_photo_alternate',
                tooltip: 'Actualizar imágenes',
                click: (dato) => this.actualizarImagenes(dato),
                oculta: (dato) => !dato.fechaAlta,
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Actualizar imágenes'),
              },
              // Modo Estacionado
              {
                tipo: 'material',
                color: 'primary',
                icon: 'local_parking',
                tooltip: 'Modo Estacionado',
                click: (dato) => this.modoEstacionado(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Modo estacionado'),
              },
              // Modo Desactivado
              {
                tipo: 'material',
                color: 'primary',
                icon: 'do_not_disturb_on',
                tooltip: 'Modo Desactivado',
                click: (dato) => this.modoDesactivado(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Vehículos - Cambiar modo desactivado',
                  ),
              },
              // Editar Cliente
              {
                tipo: 'material',
                color: 'primary',
                icon: 'drive_file_move',
                tooltip: 'Cambiar de cliente',
                click: (dato) => this.cambiarCliente(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Cambiar de cliente'),
              },
              // Servicio Técnico
              {
                tipo: 'material',
                color: 'primary',
                icon: 'build',
                tooltip: 'Servicio técnico',
                click: (dato) => this.eventoTecnico(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Vehículos - Solicitar servicio técnico',
                  ),
              },
              // Enviar Comando
              {
                tipo: 'material',
                color: 'primary',
                icon: 'send',
                tooltip: 'Enviar Comando',
                click: (dato) => this.enviarComando(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Enviar comandos'),
                // Solo mostrar si el activo tiene códigos de entrada disponibles
                oculta: (dato) =>
                  !(dato.tracker?.modelo?.codigos?.codigosEntrada?.length > 0),
              },
              // Asignar Conductor
              {
                tipo: 'material',
                color: 'primary',
                icon: 'account_box',
                tooltip: 'Asignar conductor',
                click: (dato) => this.asignarConductor(dato),
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Asignar conductor'),
              },
              // Crear Regla de Evento
              {
                tipo: 'material',
                color: 'primary',
                icon: 'rule',
                tooltip: 'Crear Regla de Evento',
                click: (dato) => this.crearReglaEvento(dato),
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Administración - Crear eventos personalizados',
                  ),
              },
              // Generar QR (oculto si no hay patente cargada)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'qr_code_2',
                tooltip: 'Generar QR',
                click: (dato) => this.generarQr(dato),
                oculta: (dato) => !dato.vehiculo?.patente,
              },
              // Finalizar recorrido dinámico (solo si tiene uno asignado)
              {
                tipo: 'material',
                color: 'primary',
                icon: 'task_alt',
                tooltip: 'Finalizar recorrido dinámico',
                click: (dato) => this.finalizarRecorridoDinamico(dato),
                oculta: (dato) => !dato.vehiculo?.idRecorridoDinamico,
                disabled: () =>
                  !this.helper.tienePermiso('Vehículos - Editar recorridos'),
              },
              // Emergencia AVL: crea la config de reenvío con periodoFin, así
              // se corta sola. Se oculta sin tracker (se declara sobre la
              // entidad tracker) y sin el módulo habilitado en el cliente.
              //
              // El flag se resuelve pidiendo el cliente en ngOnInit, NO con
              // `LoginService.getCliente()`: ese sale de sessionStorage y queda
              // viejo hasta el próximo login, así que activar el módulo no
              // hacía aparecer la acción.
              {
                tipo: 'material',
                color: 'warn',
                icon: 'emergency_share',
                tooltip: 'Emergencia AVL: declarar, o ver / ajustar la activa',
                click: (dato) => this.declararEmergenciaAvl(dato),
                oculta: (dato) => !dato.tracker?._id || !this.moduloAvlActivo,
                disabled: () =>
                  !this.helper.tienePermiso(
                    'Administración - Crear configuraciones de reenvíos',
                  ),
              },
              // Marcar como pendiente de Soflex: la sincronización sólo envía
              // los vehículos con el flag en false, así que esta es la forma de
              // forzar el reenvío de uno ya sincronizado sin editarlo.
              {
                tipo: 'material',
                color: 'primary',
                icon: 'sync_problem',
                tooltip: 'Marcar como no sincronizado con Soflex',
                click: (dato) => this.desmarcarSoflex(dato),
                oculta: (dato) =>
                  !this.botonSoflex.mostrar || dato.sincronizadoSoflex !== true,
                disabled: () => !this.helper.tienePermiso('Vehículos - Editar'),
              },
            ],
          },
        ],
      },
    });

    // Solo lectura: de las acciones queda únicamente Detalles (la primera).
    if (this.soloLectura) {
      const acciones = columnas[columnas.length - 1].row;
      acciones.accionesGrouped = acciones.accionesGrouped?.slice(0, 1);
    }

    this.columnas = columnas;
  }

  /// ¿El cliente tiene habilitado el módulo de Objetivos AVL? Se resuelve en
  /// ngOnInit contra la API para no depender de la copia del login.
  public moduloAvlActivo = false;

  private async resolverModuloAvl(): Promise<void> {
    try {
      const cliente = await firstValueFrom(this.lista2.clientePropio());
      this.moduloAvlActivo = !!cliente?.config?.integracionObjetivosAVL?.activo;
    } catch (error) {
      console.error('Error al resolver el módulo Objetivos AVL', error);
    }
  }

  /// Abre el popup de emergencia AVL sobre el tracker del vehículo. El popup
  /// resuelve la duración y el corte automático.
  public declararEmergenciaAvl(dato: IActivoTabla): void {
    const tracker = dato.tracker;
    if (!tracker?._id) {
      this.helper.notifWarn('El vehículo no tiene un tracker asignado');
      return;
    }
    // Con una emergencia vigente ya conocida se abre directo en modo ajuste
    // (el popup igual la buscaría, pero así no hay un instante en que ofrece
    // declarar otra).
    const vigente = this.emergenciaAvlDe(dato);
    const ref = this.formularios.abrir<
      EmergenciaAvlDialogComponent,
      IEmergenciaAvlData
    >(EmergenciaAvlDialogComponent, {
      tamano: 'mediano',
      data: {
        idTracker: tracker._id,
        config: vigente?._id ? vigente : undefined,
        nombreEntidad:
          dato.vehiculo?.patente ??
          dato.identificacion ??
          tracker.identificacion ??
          undefined,
        patente: dato.vehiculo?.patente,
        uniqueId: tracker.uniqueId,
      },
    });
    // Declarada, ajustada o detenida: el indicador se actualiza en el momento
    // en vez de esperar al próximo poll.
    ref.afterClosed().subscribe(async (cambio) => {
      if (!cambio || !this.activos?.length) return;
      this.emergenciasAvl = await this.cargarEmergenciasAvl(this.activos);
      this.activos = [...this.activos];
    });
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    // Mismo criterio que el botón de sincronización: sin acceso a Soflex el
    // filtro no aporta nada.
    if (this.botonSoflex.mostrar) {
      this.filtros.push(this.soflex);
    }
    // Antes de armar las columnas: de ahí sale si la acción de emergencia AVL
    // se muestra.
    await this.resolverModuloAvl();
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.activos$?.unsubscribe();
    this.reportes$?.unsubscribe();
    this.trackers$?.unsubscribe();
  }
}
